module.exports = JBrowseExports["react"];